(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    theme.settings.cartType !== 'page' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shoppable-hero"] && !Shopify.designMode) return;
  try {
    
  class IbsShoppableSlider extends HTMLElement {
    connectedCallback() {
      this.abortController = new AbortController();
      const signal = this.abortController.signal;

      this.slides = Array.from(this.querySelectorAll('[data-ibs-slide]'));
      this.dots = Array.from(this.querySelectorAll('[data-ibs-dot]'));
      this.current = 0;

      this.slides.forEach((slide, i) => {
        slide.inert = i !== 0;
      });

      const prev = this.querySelector('[data-ibs-prev]');
      const next = this.querySelector('[data-ibs-next]');
      if (prev) prev.addEventListener('click', () => this.goTo(this.current - 1, true), { signal });
      if (next) next.addEventListener('click', () => this.goTo(this.current + 1, true), { signal });

      this.dots.forEach(dot => {
        dot.addEventListener('click', () => {
          this.goTo(parseInt(dot.dataset.slideIndex, 10), true);
        }, { signal });
      });

      let touchX = null;
      this.addEventListener('touchstart', (e) => {
        touchX = e.changedTouches[0].clientX;
      }, { passive: true, signal });
      this.addEventListener('touchend', (e) => {
        if (touchX === null) return;
        const delta = e.changedTouches[0].clientX - touchX;
        touchX = null;
        if (Math.abs(delta) < 40) return;
        this.goTo(this.current + (delta < 0 ? 1 : -1), true);
      }, { passive: true, signal });

      this.autoplayDelay = parseInt(this.dataset.autoplay, 10) || 0;
      if (this.autoplayDelay && this.slides.length > 1) {
        this.startAutoplay();
        this.addEventListener('mouseenter', () => this.stopAutoplay(), { signal });
        this.addEventListener('mouseleave', () => this.startAutoplay(), { signal });
      }

      if (this.querySelector('kit-popover')) {
        window.addEventListener('scroll', () => {
          this.closePopovers();
        }, { passive: true, signal });
      }

      if (window.theme && window.theme.sections) {
        this.initQuickShop();
      } else {
        document.addEventListener('page:loaded', () => this.initQuickShop(), { once: true, signal });
      }

      if (!Shopify.designMode) return;

      document.addEventListener('shopify:section:load', (event) => {
        if (event.target.contains(this)) {
          this.initQuickShop();
        }
      }, { signal });

      this.addEventListener('shopify:block:select', (event) => {
        this.stopAutoplay();
        this.initQuickShop();

        const slide = event.target.closest('[data-ibs-slide]');
        if (slide) {
          this.goTo(parseInt(slide.dataset.slideIndex, 10), true);
        }

        if (event.target.classList.contains('kit-shoppable-hero__hotspot')) {
          const btn = event.target.querySelector('button');
          if (btn) setTimeout(() => btn.click(), 300);
        }
      }, { signal });

      this.addEventListener('shopify:block:deselect', (event) => {
        const popover = event.target.querySelector('kit-popover');
        if (popover) popover.hidePopover?.();
        if (this.autoplayDelay) this.startAutoplay();
      }, { signal });
    }

    disconnectedCallback() {
      this.stopAutoplay();
      this.abortController?.abort();
    }

    goTo(index, userInitiated) {
      if (this.slides.length < 2) return;
      const total = this.slides.length;
      const target = ((index % total) + total) % total;
      if (target === this.current) return;

      this.closePopovers();

      this.slides[this.current].classList.remove('is-active');
      this.slides[this.current].inert = true;
      this.slides[target].classList.add('is-active');
      this.slides[target].inert = false;

      this.dots.forEach((dot, i) => dot.classList.toggle('is-active', i === target));

      this.current = target;

      if (userInitiated && this.autoplayDelay) {
        this.stopAutoplay();
        this.startAutoplay();
      }
    }

    closePopovers() {
      this.querySelectorAll('kit-popover:popover-open').forEach(p => p.hidePopover());
    }

    startAutoplay() {
      if (!this.autoplayDelay) return;
      this.stopAutoplay();
      this.autoplayTimer = setInterval(() => {
        if (document.hidden) return;
        if (this.querySelector('kit-popover:popover-open')) return;
        this.goTo(this.current + 1, false);
      }, this.autoplayDelay);
    }

    stopAutoplay() {
      if (this.autoplayTimer) {
        clearInterval(this.autoplayTimer);
        this.autoplayTimer = null;
      }
    }

    initQuickShop() {
      if (!theme.settings.quickView) return;

      var sectionEl = this.closest('[id^="shopify-section-"]');
      var links = this.querySelectorAll('.shoppable-hero__popover-link[data-product-handle]');
      if (!links.length) return;

      links.forEach(link => {
        if (link.dataset.shoppableHeroBound === 'true') return;
        link.dataset.shoppableHeroBound = 'true';

        var handle = link.dataset.productHandle;
        var productId = link.dataset.productId;

        if (!document.getElementById('QuickShopModal-' + productId)) return;

        link.addEventListener('click', (event) => {
          if (theme.config.bpSmall) {
            event.stopImmediatePropagation();
            return;
          }
          const popover = event.target.closest('kit-popover');
          if (popover) popover.hidePopover?.();
        }, true);

        var hotspot = link.closest('.kit-shoppable-hero__hotspot');
        if (!hotspot) return;

        var preloadOnce = function() {
          if (link.dataset.shoppableHeroPreloaded === 'true') return;
          if (theme.config.bpSmall) return;

          var holder = document.getElementById('QuickShopHolder-' + handle);
          if (holder && sectionEl) {
            var holderSection = holder.closest('[id^="shopify-section-"]');
            if (holderSection && holderSection !== sectionEl) {
              var duplicate = sectionEl.querySelector('#QuickShopModal-' + productId);
              if (duplicate) duplicate.remove();
            }
          }

          link.dataset.shoppableHeroPreloaded = 'true';
          link.classList.add('js-modal-open-quick-modal-' + productId);
          theme.preloadProductModal(handle, productId, link);

          hotspot.removeEventListener('mouseover', preloadOnce);
          hotspot.removeEventListener('focusin', preloadOnce);
        };

        hotspot.addEventListener('mouseover', preloadOnce);
        hotspot.addEventListener('focusin', preloadOnce);
      });
    }
  }

  customElements.define('ibs-shoppable-slider', IbsShoppableSlider);

  } catch(e) { console.error(e); }
})();
})();
